import {call, put, select,take} from "redux-saga/effects";
import {getUserInfo} from "../../reducers/app";
import {CODES} from "../../constants";
import API from "../../api/api";

export function* getDeveloperInfo(): Generator<any, void, any> {
    let userInfo = yield select(getUserInfo)
    if (userInfo && userInfo.email) {
        let params = {
            email: userInfo.email,
            clientId: 'h5'
        }
        let resp = yield call(API.getDeveloperInfo, params)
        if (resp.code === CODES.SUCCESS && resp.data) {
            yield put({type: 'SET_DEVELOPER_INFO', payload: resp.data})
        }
    }
}

export function* watchGetSignKey(): Generator<any, void, any> {
    while (true){
        let {payload} = yield take('GET_SIGN_KEY')
        let userInfo = yield select(getUserInfo)
        if (userInfo && userInfo.email) {
            let params = {
                email: userInfo.email,
                clientId: 'h5',
                ...payload
            }
            let resp = yield call(API.getSignKey, params)
            if (resp.code === CODES.SUCCESS && resp.data) {
                yield put({type: 'SET_SIGN_KEY', payload: resp.data})
            }
        }
    }
}